const hostname = window.location.hostname;
const protocol = window.location.protocol;

const IS_LOCAL = hostname === "localhost" || hostname === "127.0.0.1";

let API_BASE;
if (IS_LOCAL) {
    // ---------- LOCAL ----------
    API_BASE = `${protocol}//${hostname}:8000`;
} else {
    // ---------- LIVE ----------
    API_BASE = "https://dialnepal.com.np";
}

export default API_BASE;
